import { useTranslation } from "react-i18next";
import { Flex } from "../../../../components/Flex";
import { Text } from "../../../../components/Text";

import { ActivityTimeline } from "../../../../components/activity-timeline/ActivityTimeline";
import { KanbanCardActivity } from "../../../../model/activity/KanbanCardActivity";
import { useDrawersContext } from "../../../tasks/drawers-context";
import { useAppSelector } from "../../../../redux/store";
import { kanbanSliceSelectors } from "../../../../redux/kanban/kanban.selector";

export const KanbanCardDrawerActivityTab: React.FC = () => {
  const { t } = useTranslation();
  const { kanbanCard: _kanbanCard } = useDrawersContext();

  const kanbanCard =
    useAppSelector((s) =>
      kanbanSliceSelectors.selectKanbanCardById(s, _kanbanCard?._id!),
    ) || _kanbanCard;

  if (!kanbanCard) {
    return null;
  }

  return (
    <Flex flexDirection="column" gap="m">
      <Text>
        {t("common.activity")} - {kanbanCard.title}
      </Text>
      <ActivityTimeline<KanbanCardActivity>
        activities={kanbanCard.allActivities || []}
      />
    </Flex>
  );
};
